import React from 'react';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown } from '../../Core';
import { ListFieldSection } from '../../../Layout';
import { Field } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../Core/WorksheetEquipment';

let CompactionWaterContentDeterminationEquipmentSection: React.FC = () => {
  return (
    <ListFieldSection>
      <WorksheetBalanceFieldSet label="Balance" name="Equipment.MoistureDeterminationBalance" />

      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Oven"
        equipmentType="oven"
        name="Equipment.MoistureDeterminationOven"
      />

      <WorksheetBalanceFieldSet label="Dry Mass Balance" name="Equipment.MoistureDeterminationDryMassBalance" />
    </ListFieldSection>
  );
};

CompactionWaterContentDeterminationEquipmentSection = withInjectedProps(
  CompactionWaterContentDeterminationEquipmentSection
);

export { CompactionWaterContentDeterminationEquipmentSection };
export default CompactionWaterContentDeterminationEquipmentSection;
